@if (visible) {
  <ion-card class="ardoq-card" (click)="open()">
    <div class="ardoq-card-img-container">
      @if (embed.ImageURI) {
        <ion-img class="ardoq-card-img" [src]="embed.ImageURI"></ion-img>
      }
      @if (!embed.ImageURI) {
        <div class="ardoq-icon-container">
          <ion-icon name="analytics-outline" class="ardoq-icon"></ion-icon>
        </div>
      }
      <!-- <ion-icon *ngIf="embed.Pinned" name="pin-outline" class="report-card-pin-badge"></ion-icon> -->
    </div>
    <div class="ardoq-card-info">
      <div class="ardoq-card-collection">
        <span>{{ embed.Label }}</span>
      </div>
      @if (collapsableTitle) {
        <div class="ardoq-card-title-text">{{ collapsableTitle }}</div>
      } @else {
        @if (embed) {
          <div class="ardoq-card-title-text">{{ embed.CollapsableTitle }}</div>
        }
      }
    </div>
    <div class="ardoq-card-embed-option">
      <ion-icon [name]="embed.EmbedOption === 'iframe' ? 'browsers-outline' : 'open-outline'"></ion-icon>
      <span>{{ (embed.EmbedOption === 'iframe' ? 'Iframe' : 'New page') | translate }}</span>
    </div>
    <div class="ardoq-card-footer">
      <ion-button [color]="embed.IsFavorite ? 'primary' : 'medium'" (click)="setAsFavorite($event)" class="embed-card-fav-btn">
        <ion-icon [name]="embed.IsFavorite ? 'star' : 'star-outline'" slot="start"></ion-icon>
        <span>{{ embed.IsFavorite ? ('Unfavorite' | translate) : ('Favorite' | translate) }}</span>
      </ion-button>
    </div>
  </ion-card>
}
